import { Web3, FMT_NUMBER, FMT_BYTES } from 'web3';
import { toBigInt, toHex } from 'web3-utils';
import { Contract } from 'web3-eth-contract';
import PublisherNFTEscrow from "../assets/abi/PublisherNFTEscrow.json";
import PublisherNFT from "../assets/abi/PublisherNFT.json";
import GenesisNFTEscrow from "../assets/abi/GenesisEscrow.json";
import GenesisNFT from "../assets/abi/GenesisNFT.json";
import PayoutClaim from "../assets/abi/PayoutClaim.json";


const contractMap = {
    "PublisherNFTEscrow": PublisherNFTEscrow,
    "PublisherNFT": PublisherNFT,
    "GenesisEscrow": GenesisNFTEscrow,
    "GenesisNFT": GenesisNFT,
    "PayoutClaim": PayoutClaim
}

const contractAddressMap = {
    "PublisherNFTEscrow": process.env.REACT_APP_PNFT_ESCROW_CONTRACT_ADDRESS,
    "PublisherNFT": process.env.REACT_APP_PNFT_TOKEN_CONTRACT_ADDRESS,
    "GenesisEscrow": process.env.REACT_APP_GENESIS_ESCROW_CONTRACT_ADDRESS,
    "GenesisNFT": process.env.REACT_APP_GENESIS_TOKEN_CONTRACT_ADDRESS,
    "PayoutClaim": process.env.REACT_APP_CLAIM_CONTRACT_ADDRESS
}

function getABI(addressOrName) {
    // const network = abiApiNetworkMapping[networkId];
    // const cacheKey = `${networkId}://${addressOrName}`;

    return contractMap[addressOrName];
}

// let web3Configs = {};
/**
 * 
 * @param {string} networkId 
 * @returns {Web3}
 */
// export function getWeb3(networkId) {
//     if(web3Configs[networkId]) return web3Configs[networkId];

//     const provider = providers[networkId];
//     if(!provider) {
//         throw `default web3 provider not configured on chain ${networkId}`;
//     }

//     const web3 = new Web3(provider);
//     web3Configs[networkId] = web3;
//     return web3;
// }

export async function getPriorityGasEstimate(web3, multiplier = 2) {
    // const web3 = getWeb3(networkId);

    const prioGas = await web3.eth.getMaxPriorityFeePerGas({ number: FMT_NUMBER.HEX , bytes: FMT_BYTES.HEX });

    return toHex(toBigInt(prioGas) * toBigInt(multiplier));
}

export function getContractAddress(contractIden) {
    return contractAddressMap[contractIden];
}

/**
 * 
 * @param {string} contractIden 
 * @param {Web3} web3 
 * @param {string} networkId 
 * @returns {Contract}
 */
export function getContract(contractIden, web3) {
    if(!web3) {
        throw new Error(`web3 instance is missing for ${contractIden}`)
    }

    const Contract = web3.eth.Contract;

    try {
        // let [addressOrName, abis] = contractIden.split("/")

        const abi = getABI(contractIden);
        const address = contractAddressMap[contractIden]

        // console.log(contractIden, address)

        const contract = new Contract(abi, address);
        contract.transactionConfirmationBlocks = 1;
        return contract;
    } catch(e) {
        console.error(e)
        throw `ABI not found for contract ${contractIden}`;
    }
}